module.exports = __webpack_public_path__ + "img/microneedling-treatment-mobile-ru.6830a595.jpg";